document.addEventListener('DOMContentLoaded', function () {
  var btn = document.querySelector('.upsell-product-card__btn[data-upsell-variant]');
  if (!btn) return;

  btn.addEventListener('click', function (event) {
    event.stopImmediatePropagation();
    event.stopPropagation();
    event.preventDefault();

    var variantId = this.dataset.upsellVariant;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: 'cart-drawer,cart-icon-bubble'  // ← Shopify visszaadja a kész HTML-t
      })
    })
    .then(r => r.json())
    .then(addResponse => {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: addResponse,           // item_count itt is benne van
          data: {
            sections: addResponse.sections // ← ezt várja a component-cart-items.js
          }
        }
      }));

      var drawer = document.querySelector('cart-drawer-component');
      if (drawer) drawer.open();
    })
    .catch(err => console.error('Upsell hiba:', err));

  }, true);
});